import {useEffect, useMemo} from 'react'
import {DataCDR} from '../core/_models'
import {useParams} from 'react-router-dom'
import {CustomRow} from './columns/CustomRow'
import {CDRColumns} from './columns/_columns'
import {Pagination} from '../components/Pagination'
import {cdrAPI} from '../../../services/CDRService'
import {KTCardBody} from '../../../template/helpers'
import {updateQuery} from '../slices/cdrFilterSlice'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {useAppDispatch, useAppSelector} from '../../../hooks/redux'
import {TableLoading} from '../../../template/helpers/TableLoading'
import {useQueryCDREntitiesRequest} from '../hooks/useQueryCDRUsersRequest'
import {useAccount} from '../../../hooks/useAccount'
import {shallowEqual} from 'react-redux'

const CDRTable = () => {
  const {appId} = useParams()
  const dispatch = useAppDispatch()
  const {setUsers, setLines} = useQueryCDREntitiesRequest()
  const {currentAccountIdForRequest: accountId} = useAccount()
  const query = useAppSelector((state) => state.cdrFilter.query, shallowEqual)

  const isReady = query?.period !== undefined
  const {
    data: response,
    isLoading,
    isFetching,
  } = cdrAPI.useDataFetchQuery({id: appId!, filter: {...query}, account_id: accountId}, {skip: !isReady})

  const {data: cdrUsers} = cdrAPI.useGetUsersQuery(appId!)
  const {data: cdrLines} = cdrAPI.useGetLinesQuery(appId!)
  const data = response ? (response?.data as DataCDR[]) : []

  const columns = useMemo(() => CDRColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  useEffect(() => {
    if (!cdrUsers) return
    setUsers(cdrUsers.users)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cdrUsers])

  useEffect(() => {
    if (!cdrLines) return
    setLines(cdrLines.lines)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cdrLines])

  return (
    <KTCardBody className='pt-1 pb-4'>
      {(isLoading || isFetching) && <TableLoading />}
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<DataCDR>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<DataCDR>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>---</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className='row mt-5'>
        <div className='col-2 d-flex align-items-center mb-sm-3 justify-content-start'>
          <label>
            <select
              className='form-select form-select-sm form-select-solid'
              value={query?.limit || 10}
              onChange={(e) => {
                dispatch(updateQuery({...query, limit: parseInt(e.target.value), offset: 0}))
              }}
            >
              <option value='10'>10</option>
              <option value='25'>25</option>
              <option value='50'>50</option>
              <option value='100'>100</option>
              <option value='500'>500</option>
            </select>
          </label>
          <div className='ps-2'>Всего: {response && response.total ? response.total : 0}</div>
        </div>
        {response && response.total ? <Pagination maxLength={response.total} /> : <Pagination maxLength={1} />}
      </div>
    </KTCardBody>
  )
}

export {CDRTable}
